import React, { FunctionComponent, ReactNode } from "react";
import {
  Datepicker,
  HelpText,
  Label,
  ValidationMessage,
} from "@gjensidige/builders-components";
import { Locale } from "date-fns";

interface Props {
  id: string;
  labelText: ReactNode;
  helpText?: ReactNode;
  value?: Date | string | number;
  invalid?: boolean;
  onChange?:
    | ((date: Date | undefined, value: string, input: HTMLInputElement) => void)
    | undefined;
  onBlur?: React.FocusEventHandler<HTMLInputElement> | undefined;
  errorText?: ReactNode;
  format?: string;
  locale?: Locale;
  parse?: string;
  max?: Date | string | number;
  min?: Date | string | number;
}

const FormDatePicker: FunctionComponent<Props> = ({
  invalid,
  onChange,
  helpText,
  value,
  onBlur,
  errorText,
  id,
  labelText,
  ...rest
}) => {
  return (
    <div>
      <Label htmlFor={id}>{labelText}</Label>
      {helpText && <HelpText htmlFor={id}>{helpText}</HelpText>}
      <Datepicker
        id={id}
        name={id}
        onChange={onChange}
        onBlur={onBlur}
        invalid={invalid}
        value={value}
        labelDropdownMonth={"Måned"}
        labelDropdownYear={"År"}
        labelToggleButton={"Kalender"}
        {...rest}
      />
      <ValidationMessage htmlFor={id} hidden={!invalid} invalid={invalid}>
        {errorText}
      </ValidationMessage>
    </div>
  );
};

export default FormDatePicker;
